import React from 'react'

const ProfileDropdown = ({ logoUrl, appName, slogan }) => {
  return (
    <>
      <a
        className='nav-link nav-profile d-flex align-items-center pe-0'
        href='#'
        data-bs-toggle='dropdown'
      >
        <img src={logoUrl} alt='Profile' className='rounded-circle' />
        <span className='d-none d-md-block dropdown-toggle ps-2'>
          {appName}
        </span>
      </a>
      {/* <!-- End Profile Iamge Icon --> */}

      <ul className='dropdown-menu dropdown-menu-end dropdown-menu-arrow profile'>
        <li className='dropdown-header'>
          <h6>{appName}</h6>
          <span>{slogan}</span>
        </li>

        <li>
          <hr className='dropdown-divider' />
        </li>
      </ul>
    </>
  );
};

export default ProfileDropdown